var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionsButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4462 10.9501L27.2426 8L29.7057 8.79991L30.2339 12.8312L31.9175 14.0543L35.9175 13.3112L37.4392 15.4062L35.4944 18.9779L36.138 20.9575L39.8082 22.7049V25.2951L36.138 27.0425L35.4944 29.0221L37.4366 32.5938L35.9149 34.6888L31.9149 33.9457L30.2313 35.1688L29.7057 39.2001L27.2426 40L24.4462 37.0499H22.3646L19.5681 40L17.105 39.2001L16.5773 35.1688L14.8937 33.9457L10.8937 34.6888L9.37153 32.5938L11.3138 29.0221L10.6706 27.0425L7 25.2951V22.7049L10.6706 20.9575L11.3138 18.9779L9.37153 15.4062L10.8937 13.3112L14.8937 14.0543L16.5773 12.8312L17.105 8.79991L19.5681 8L22.3646 10.9501H24.4462ZM30.9192 24C30.9192 28.4184 27.3376 32 22.9192 32C18.5008 32 14.9192 28.4184 14.9192 24C14.9192 19.5816 18.5008 16 22.9192 16C27.3376 16 30.9192 19.5816 30.9192 24ZM22.9194 28.4449C25.3738 28.4449 27.3638 26.4548 27.3638 24.0004C27.3638 21.546 25.3738 19.556 22.9194 19.556C20.4649 19.556 18.4749 21.546 18.4749 24.0004C18.4749 26.4548 20.4649 28.4449 22.9194 28.4449Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsButton);
export default __webpack_public_path__ + "static/media/options_Button.2c0ac907216bdf87a26ca17577389ab3.svg";
export { ForwardRef as ReactComponent };